// extracted by mini-css-extract-plugin
export var cardLayout = "_7m-1";
export var paginationContainer = "_7m-0";